<template>
  <form @submit.prevent="updateEmailTemplate()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Edit Car Type Email Template
        </h5>
        <button
          ref="modalCloseBtn"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-sm-2">
            <label for="">User Type</label>
            <select class="form-select" v-model="formValue.user_type" required>
              <option value="">--Select--</option>
              <option value="partner">Partner</option>
              <option value="b2b_ops">B2B Ops</option>
              <option value="b2c_ops">B2C Ops</option>
            </select>
          </div>
          <div class="col-sm-4">
            <label for="">To Mail</label>
            <input
              v-for="index in numOfToMail"
              :key="index"
              type="email"
              class="form-control mail-field"
              v-model="formValue.to_mail[index - 1]"
              required
            />
          </div>
          <div class="col-sm-1" style="display: flex; align-items: end">
            <button
              class="btn btn-primary"
              type="button"
              @click="numOfToMail++"
            >
              +
            </button>
            <button
              v-if="numOfToMail > 1"
              class="btn btn-secondary"
              style="margin-left: 3px"
              type="button"
              @click="numOfToMail--"
            >
              -
            </button>
          </div>
          <div class="col-sm-4">
            <label for="">CC Mail</label>
            <input
              v-for="index in numOfCCMail"
              :key="index"
              type="email"
              class="form-control mail-field"
              v-model="formValue.cc_mail[index - 1]"
              required
            />
          </div>
          <div class="col-sm-1" style="display: flex; align-items: end">
            <button
              class="btn btn-primary"
              type="button"
              @click="numOfCCMail++"
            >
              +
            </button>
            <button
              v-if="numOfCCMail > 1"
              class="btn btn-secondary"
              style="margin-left: 3px"
              type="button"
              @click="numOfCCMail--"
            >
              -
            </button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label for="">Subject</label>
            <textarea
              class="form-control"
              rows="3"
              v-model="formValue.subject"
              required
            ></textarea>
          </div>
          <div class="col-sm-6">
            <label for="">Body</label>
            <textarea
              class="form-control"
              rows="3"
              v-model="formValue.body"
            ></textarea>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-sm-6">
            <label for="">Template 3</label>
            <textarea
              class="form-control"
              rows="3"
              v-model="formValue.template3"
            ></textarea>
          </div>
          <div class="col-sm-6">
            <label for="">Template 4</label>
            <textarea
              class="form-control"
              rows="3"
              v-model="formValue.template4"
            ></textarea>
          </div>
        </div> -->
      </div>
      <div class="modal-footer">
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">Update</button>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/config/axios';

export default {
  props: ['emailTemplate'],
  data() {
    return {
      formValue: {
        user_type: '',
        to_mail: [],
        cc_mail: [],
        subject: null,
        body: null
        // template3: null,
        // template4: null
      },
      numOfToMail: 1,
      numOfCCMail: 1,
      isLoading: false
    };
  },
  watch: {
    emailTemplate() {
      this.numOfToMail = this.emailTemplate.to_mail?.split(',')?.length;
      this.numOfCCMail = this.emailTemplate.cc_mail?.split(',')?.length;
      this.formValue = {
        user_type: this.emailTemplate.user_type,
        to_mail: this.emailTemplate.to_mail?.split(','),
        cc_mail: this.emailTemplate.cc_mail?.split(','),
        subject: this.emailTemplate.subject,
        body: this.emailTemplate.body
        // template3: this.emailTemplate.template3,
        // template4: this.emailTemplate.template4
      };
    },
    numOfToMail() {
      if (this.formValue.to_mail[this.numOfToMail]) {
        this.formValue.to_mail?.pop();
      }
    },
    numOfCCMail() {
      if (this.formValue.cc_mail[this.numOfCCMail]) {
        this.formValue.cc_mail?.pop();
      }
    }
  },
  methods: {
    emptyFormValues() {
      this.formValue = {
        user_type: '',
        to_mail: [],
        cc_mail: [],
        subject: null,
        body: null
        // template3: null,
        // template4: null
      };
    },
    updateEmailTemplate() {
      this.isLoading = true;
      http
        .put(`v2/settings/mails/${this.emailTemplate.id}`, {
          user_type: this.formValue.user_type,
          to_mail: this.formValue.to_mail?.join(','),
          cc_mail: this.formValue.cc_mail?.join(','),
          subject: this.formValue.subject,
          body: this.formValue.body
          // template3: this.formValue.template3,
          // template4: this.formValue.template4
        })
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.$swal('Success', response.data.message, 'success');
            this.$refs.modalCloseBtn.click();
            this.emptyFormValues();
            this.$emit('refreshEmailTemplateList');
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', error.response.data?.message, 'error');
        });
    }
  }
};
</script>

<style scoped>
.mail-field {
  margin-bottom: 8px;
}
.mail-field:last-child {
  margin-bottom: 0;
}
</style>
